var map = {
	"./de/video-btn.png": "UrD8",
	"./en/video-btn.png": "oy+y",
	"./es/video-btn.png": "C/W7",
	"./fr/video-btn.png": "QcqJ",
	"./ja/video-btn.png": "iLkw",
	"./ko/video-btn.png": "NdKR",
	"./pt/video-btn.png": "fUYa",
	"./ru/video-btn.png": "xeec",
	"./tc/video-btn.png": "uxGj",
	"./th/video-btn.png": "vlVW"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "EDvv";